<template>
  <div :class="classes()">
            <div class="float-top">
                <div class="flex flex-hcenter flex-vcenter txt-111 date-tit">
                    <div class="close-btn" @click="onCloseDatePicker"></div>
                    <p class="txt36">选择上课时间</p>
                    <span class="txt28 plr10" @click="onClearSelectedHandler">清除</span>
                </div>
                <div class="txt-center">
                    <div className="time-tip" v-if="groups().length>0">已选择</div>
                    <div className="time-tip" v-else-if="rate === 2">请选择每周固定学习日</div>
                    <div className="time-tip" v-else>请选择课次</div>
                </div>
                <div class="time-line-wrap pt25">
                    <div v-if="groups().length === 0" class="empty-card time-line-tip">
                        所选课次时间会展示在这
                    </div>
                    <div class="time-line-list">
                      <template v-for="groupItem in groups()">
                              <DateGroupWeeklyCard
                                  v-if="rate === NewSignCourseRateEnum.Weekly"
                                  :key="groupItem.groupId"
                                  :datesGroupSelectedStart="datesGroupSelectedStart"
                                  :datesGroupSelectedEnd="datesGroupSelectedEnd">
                              </DateGroupWeeklyCard>
                              <ul v-else-if="rate === NewSignCourseRateEnum.Unlimit" class="time-line plr15 flex">
                                  <li class="item plr15 col-60" :key="groupItem.groupId">
                                      <a href="javascript:void(0);" class="time-line-txt rel">
                                          {{groupItem.date}}
                                          <span class="txt-999 pl10">{{groupItem.dayofweek}}</span>
                                          <span class="border-spe mlr10"></span>
                                          <i class="icon-close"></i>
                                      </a>
                                  </li>
                              </ul>
                        </template>
                    </div>
                </div>
            </div>
            <div class="months">
                    <MonthlyDatePicker
                        v-for="monthInfo in monthList"
                        :key="monthInfo.year + '' + monthInfo.month"
                        :year="monthInfo.year"
                        :month="monthInfo.month"
                        :datesGroup="datesGroup"
                        :selectedDateGroupMap="selectedDateGroupMap"
                        @onDateChangeHandler="onDateChangeHandler"
                        :selectMode="selectMode"
                        :datesGroupSelectedStart="datesGroupSelectedStart"
                        :datesGroupSelectedEnd="datesGroupSelectedEnd"
                        :rate="rate"
                    >
                    </MonthlyDatePicker>
            </div>
            <div class="bottom-btn">
                <a class="btn-submit btn-origin" @click="onClickSaveHandler">保存</a>
            </div>
        </div>
</template>
<script>
import MonthlyDatePicker from './MonthlyDatePicker'
import DateGroupWeeklyCard from './DateGroupWeeklyCard'
import _ from 'lodash'
import api from '@/common/libs/api'

export default {
  name: 'MultiMonthlyDatePicker',
  data(){
    return {
      selectedDateGroupMap: {},
      datesGroupSelectedStart: null,
      datesGroupSelectedEnd: null,
      monthList: [],
      NewSignCourseRateEnum: api.CodeMap.NewSignCourseRateEnum
    }
  },
  props: {
    selectMode: String,
    startDate: String,
    endDate: String,
    rate: Number,
    groupLimit: Number,
    openDatesPicker: {
      type: Boolean,
      default(){
        return false
      }
    },
    datesGroup: {
      type: Array,
      default(){
        return []
      }
    }
  },
  components: {
    MonthlyDatePicker,
    DateGroupWeeklyCard
  },
  methods: {
    init (){
      var startDate = new Date(this.startDate.replace(/-/g, '/'));
      var endDate = new Date(this.endDate.replace(/-/g, '/'));
      //按月取日历
      var monthArray = this.getAllMonths(startDate, endDate);
      this.monthList = monthArray;
    },
    //获取时间段内的所有月份
    getAllMonths(startDate, endDate){
      var result = [];
      var startYear = startDate.getFullYear();
      var startMonth = startDate.getMonth();
      var endYear = endDate.getFullYear();
      var endMonth = endDate.getMonth();
      var mCount = 0;
      if (endYear - startYear > 0) {
        mCount = (endYear - startYear) * 12 + endMonth - startMonth + 1;
      } else {
        mCount = endMonth - startMonth + 1;
      }
      if (mCount > 0) {
        for (var i = 0; i < mCount; i++) {
          if (startMonth < 11) {
            result[i] = {year: startYear, month: startMonth};
            startMonth += 1;
          } else {
            result[i] = {year: startYear, month: startMonth};
            startMonth = 0;
            startYear += 1;
          }
        }
      }
      return result;
    },
    groups(){
      return  _.values(this.selectedDateGroupMap);
    },
    classes(){
      return ["multi-monthly-date-picker date-picker-mask", {"rollOut": this.openDatesPicker}];
    },
    onDateChangeHandler(date){
        console.log('onDateChangeHandler:====', date);
        if (!date.dateValue){
            this.$store.dispatch('toast', {title: '暂无时段，请选择其他日期', show: true});
            return false;
        }
        var selectedDateGroupMap = this.selectedDateGroupMap;
       
        if (date.highlight) {
            if (selectedDateGroupMap[date.groupId]) {
                delete selectedDateGroupMap[date.groupId];
                this.selectedDateGroupMap = selectedDateGroupMap;
            } else if (this.groupLimit == 1) {
                this.selectedDateGroupMap =  {};
                this.selectedDateGroupMap[date.groupId] = date;
            } else if (_.keys(selectedDateGroupMap).length <= this.groupLimit) {
                selectedDateGroupMap[date.groupId] = date;
                this.selectedDateGroupMap = selectedDateGroupMap;
            } else {
                this.$store.dispatch('toast', {title: '超出选择数限制', show: true});
                return;
            }

            var currentGroupDates = this.formatSelectedGroupDates();
            var first = _.first(currentGroupDates);
            var last = _.last(currentGroupDates);
            this.datesGroupSelectedStart = first;
            this.datesGroupSelectedEnd = last;
        }
    },
    /**
     * 格式化选择的日期
     * */
    formatSelectedGroupDates(){
        var groupIds = _.keys(this.selectedDateGroupMap);
        var currentGroupDates = [];
        groupIds.map(groupId => {
            var currentGroup = this.selectedDateGroupMap[groupId];
            currentGroupDates = _.filter(this.datesGroup, (dateItem) => {
                if (this.selectMode == 1) {
                    var dateValue = currentGroup.dateValue;
                    var endDate = dateValue.split('|')[1];
                    var startDate = dateValue.split('|')[0];
                    return dateItem.groupId == groupId && dateItem.date <= endDate && dateItem.date >= startDate;
                } else {
                    return dateItem.groupId == groupId;
                }
            });
        });
        return currentGroupDates;
    },
    onClickSaveHandler(){
      var currentGroupDates = this.formatSelectedGroupDates();
      if (currentGroupDates.length === 0){
        this.$store.dispatch('toast', {title: '请选择上课日期', show: true});
      } else {
        this.$emit('onSaveGroupIdsHandler', currentGroupDates);
      }
    },
    onCloseDatePicker(){
      console.log('关闭日历选择器');
      this.$emit('onCloseDatePicker');
    },
    onClearSelectedHandler(){
        this.selectedDateGroupMap = {};
    }
  },
  mounted(){
    this.init();
  }
}
</script>


// WEBPACK FOOTER //
// src/components/courseCenter/newsign/MultiMonthlyDatePicker.vue